<template>
  <div class="ds-form-item ds-neweditor" :class="getCss">
    <div ref="editorScroll">
      <DsfFieldLabel
        v-if="showLabel"
        :mode="showDataCaptionMode"
        :style="getLabelWidthStyle()"
        :show-icon="showDataCaptionIcon" 
        :trigger="showDataCaptionTrigger"
        :data-caption="dataCapion"
        :is-design="isDesign"
        :owner="_self">
        {{ $t(label) }}
      </DsfFieldLabel>
      <div class="ds-form-block" :style="getFormItemBlockMarginLeft()">
        <div v-if="showEditor && !(isDesign && readOnly)" ref="neweditorContent" class="neweditor-content" :class="{'fix-toolbar' : fixToolbar}">
          <div v-show="!readOnly" id="editor-toolbar" ref="editorToolbar">
            <div :id="'toolbar-container_' + hash"></div>
          </div>
          <div class="editor-container" :class="[!isHideMenu ? 'float-catalog' : catalogPos === 'left' ? 'catalog-left' : 'catalog-right']">
            <div class="editor-box" :class="{'full-width':!isShowSideBar}">
              <div class="editor-input" :class="codeTheme" :style="(resetWidth && resetWidth > 0) ? returnResetWidth(): ''" ref="editorInput" :id="'editor-container_' + hash" @click="handleClickInput"></div>
              <div v-if="wordCount" class="wrod-msg">{{msgCountTip}}</div>
              <!-- <div v-if="readOnly" class="readonly-mask"> </div> -->
            </div>
            <div v-if="isShowSideBar" class="editor-sidebar" ref="editorSidebar" :style="setEditorSidebarPos()" :class="[!isHideMenu ? 'float-catalog' : '',catalogPos === 'left' ? 'catalog-left' : 'catalog-right', isHover ? 'isHover' : '']">
              <div class="compendium">
                <span class="title">大纲</span>
                <span class="pithy">
                  <el-tooltip class="item" effect="dark" :content="isHideMenu?'隐藏大纲':'钉住大纲'" placement="top-start">
                    <i :class="isHideMenu?'el-icon-unlock':'el-icon-lock'" @click="handleHideMenu"></i>
                  </el-tooltip>
                </span>
                <span class="on-off" v-if="isShowCloseTree(menuTree)">
                  <el-tooltip class="item" effect="dark" :content="isCloseAll?'全部展开':'全部折叠'" placement="top-start">
                    <i :class="isCloseAll?'el-icon-caret-bottom':'el-icon-s-unfold'" @click="isOpenOrClose"></i>
                  </el-tooltip>
                </span>
              </div>
              <div class="menu-tree-box">          
                <dsf-virtual-scroll>
                  <el-tree 
                    v-if="menuTree.length>0"
                    ref="menuTree"
                    class="menu-tree"
                    :data="menuTree" 
                    :current-node-key="currentNodeKey"
                    node-key="id" 
                    :default-expand-all="isExpand"
                    :highlight-current="true" 
                    :expand-on-click-node="false" 
                    @node-click="nodeClick"
                    @node-expand="nodeExpand"
                    @node-collapse="nodeCollapse">
                    <template slot-scope="{node, data}">
                      <span :class="'tree-node-label el-tree-slot_padding-'+data.indent">{{node.label}}</span>
                    </template>
                  </el-tree>
                  <span v-if="menuTree.length < 1 && !readOnly" class="menu-placeholder">标题将在此展示</span>
                </dsf-virtual-scroll>
                <img v-if="!isHideMenu" :src="require('_platform/assets/styles/themes/img/switch.png')" alt class="fix-icon" />
              </div>
            </div>
          </div>
        </div>
        <div v-if="isDesign && readOnly" id="designReadOnly" :class="ueditorCss" v-text="msg"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { recursionHandleTree } from "./handleEditorMenuTree.js";
export default dsf.component({
  name: "DsfWangEditor",
  mixins: [$mixins.formControl],
  ctrlCaption: "富文本",
  props: {
    value: {
      type: String,
      default: ""
    },
    richTxtHeight: {
      type: Number,
      default: 800
    },
    fixedOffsetTop: {
      type: Number,
      default: 0
    },
    fixedOffsetClass: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: "请在此输入正文..."
    },
    metadata: {
      type: Object,
      default() {
        let md = dsf.metadata.get("big-text-meta-data");
        md.valueAttributes[0].textType = "HTML";
        return md;
      }
    },
    fixToolbar: {
      type: Boolean,
      default: true
    },
    toolBars: {
      type: Array,
      default() {
        return [
          'headerSelect',
          'blockquote',
          'underline',
          'bold',
          'italic',
          'through',
          'code',
          'sub',
          'sup',
          'clearStyle',
          'color',
          'bgColor',
          'fontSize',
          'fontFamily',
          'indent',
          'delIndent',
          'justifyLeft',
          'justifyRight',
          'justifyCenter',
          'justifyJustify',
          'lineHeight',
          'divider',
          'emotion',
          'insertLink',
          'codeBlock',
          'todo',
          'redo',
          'undo',
          'bulletedList',
          'numberedList',
          'uploadVideo',
          'insertTable',
          'uploadAttachment',
          'uploadImage'
        ];
      }
    },
    catalogPos: {
      type: String,
      default: 'right'
    },
    showLabel: {
      type: Boolean,
      default: false
    },
    maximumWords: {
      type: Number,
      default: 10000
    },
    wordCount: {
      // 是否开启字数统计
      type: Boolean,
      default: false
    },
    wordCountMsg: {
      // 字数统计提示
      type: String,
      default: "当前已输入 {#count} 个字符，您还可以输入{#leave} 个字符"
    },
    valueIsHtml: {
      type: Boolean,
      default: true
    },
    pasteImgByCut: {
      type: Boolean,
      default: false
    },
    // 只读状态下，是否自动高度
    readOnlyAutoHeight: {
      type: Boolean,
      default: false
    },
    // 只读状态下，是否显示名称
    readOnlyShowLabel: {
      type: Boolean,
      default: false
    },
    //代码块风格
    codeTheme:{
      type: String,
      default: "dark-themes"
    },
    //是否显示侧边栏目录
    isShowSideBar: {
      type:Boolean,
      default:true
    },
    //富文本输入框宽度设置，如果设置则使用
    resetWidth:{
      type:[Number,String],
      default:0
    }
  },
  data() {
    return {
      weditortool: null,
      showEditor: true,
      editorValue: '',
      upFileUrl: "file/upload/",
      toolbarConfig: {
        toolbarKeys: this.toolBars
      },
      menuTree:[],
      isExpand:true,
      isCloseAll:false,
      isHideMenu:true,
      currentNodeKey:null,
      msgCountTip: '',
      v: null,
      offsetTop: 0,
      headerList:[],
      scrollTimer: null,
      needScrollJudge:true,
      haveChange:false,
      designerMenu:[{label:"标题一",level:1,id:"no001",children:[{label:"标题二",level:2,id:"no002",children:[{label:"标题三",level:3,id:"no003",children:[]}]}]}],
      designerEditorHtml:`<pre><code class="language-javascript">&lt;script&gt;var str = 'Hello World !'&lt;/script&gt;</code></pre>
      <pre><code class="language-html">&lt;div class="zh-title"&gt;&lt;strong&gt;Hello World！&lt;/strong&gt;&lt;div&gt;</code></pre>
      <pre><code class="language-css">&lt;link rel="stylesheet" href="https://www.baidu.com"&gt;`,
      wangeditorScriptLoading: false,
      treeHeight:0,
      hash: dsf.uuid(),
      isHover: false
    };
  },
  computed: {
    hasLabel() {
      if (this.showLabel) {
        if (this.readOnly) {
          return this.readOnlyShowLabel;
        }
        return true;
      }
      return false;
    },
    ueditorCss() {
      return this.hasLabel ? "have-label" : "";
    },
    msg() {
      const txt = "已经启用只读模式，";
      return this.visible ? txt + "可见" : txt + "且不可见";
    }
  },
  watch: {
    toolBars() {
      this.renderNewEditor();
    },
    value(v) {
      this.v = v;
      if (!this.weditortool) return;
      let editorValue = this.weditortool.getHtml();
      if (v !== editorValue) {
        this.v = null;
        this.insertText(v)
      }
    },
    codeTheme:{
      handler(newValue,oldValue){
        this.codeTheme = newValue;
      },
      deep:true,
      immediate:true
    },
    currentNodeKey(id){
      if(id.toString()){
        this.$nextTick(()=>{
          this.currentNodeKey = id;
          this.$refs["menuTree"].setCurrentKey(this.currentNodeKey);
        })
      }
    },
    headerList:{
      handler(newValue, oldValue){
        if(!this.isDesign){
          this.menuTree = recursionHandleTree(this.headerList);
          this.$nextTick(() => {
            if(this.menuTree.length > 0){
              if(!this.isHideMenu){
                this.handleHideMenu()
              }
              let offsetTopList = [];
              for(let i = 0; i < this.headerList.length; i++){
                offsetTopList.push({id:this.headerList[i].id,top:this.$el.querySelector(`#${this.headerList[i].id}`).getBoundingClientRect().top})
              }
              this.currentNodeKey = this.judgeTopItem(offsetTopList).id;
              this.$refs["menuTree"].setCurrentKey(this.currentNodeKey);
            }else{
              //大纲内容为空时，隐藏大纲
              if(this.isHideMenu){
                this.handleHideMenu()
              }
            }
          })
        }
      },
      deep:true,
      immediate:true
    }
  },
  mounted() {
    this.loadWEditor()
    if (this.fixedOffsetClass) {
      var ele = document.getElementsByClassName(this.fixedOffsetClass)[0]
      ele.addEventListener("scroll", this.handleScroll, true);
    } else {
      window.addEventListener("scroll", this.handleScroll, true);
    }
    if(this.isDesign){
      this.menuTree = this.designerMenu;
      this.currentNodeKey = "no001"
    }
  },
  methods: {
    loadWEditor () {
      return this.loadWangEditor().then(() => {
        if (window.wangEditor && window.wangEditor.Boot.plugins.length < 13) window.wangEditor.Boot.registerModule(window.WangEditorPluginUploadAttachment.default)
        this.initEditor()
      }).catch((ex) => {
        dsf.error(ex)
      });
    },
    loadWangEditor() {
      return new Promise((reslove, reject) => {
        if (!window.wangEditor) {
          if (!this.wangeditorScriptLoading) {
            this.wangeditorScriptLoading = true;
            // 订阅加载script事件
            let head = document.getElementsByTagName('head')[0];
            let element = document.createElement("link");
            element.setAttribute("rel", "stylesheet");
            element.setAttribute("type", "text/css");
            element.setAttribute("href", './static/js/libs/wangeditor/style.css');
            head.appendChild(element);
            let script = document.createElement('script');
            head.appendChild(script);
            script.src = './static/js/libs/wangeditor/index.js';
            script.onload = () => {
              let script2 = document.createElement('script');
              head.appendChild(script2);
              script2.src = './static/js/libs/wangeditor/attachment.js';
              script2.onload = () => {
                reslove()
              }
            }
          }
        } else {
          reslove();
        }
      })
    },
    initEditor () {
      let _this = this
      let weditortool = window.wangEditor.createEditor({
        selector: `#editor-container_${_this.hash}`,
        config: {
          placeholder: _this.readOnly ? '' : _this.placeholder,
          hoverbarKeys: {
            attachment: {
              menuKeys: ['downloadAttachment'], // “下载附件”菜单
            },
          },
          MENU_CONF: {
            uploadImage: {
              customUpload (file, insertFn) {
                _this.uploadFile(file, insertFn, 'img');
              }
            },
            uploadVideo: {
              customUpload: (file, insertFn) => {
                _this.uploadFile(file, insertFn, 'video');
              }
            },
            uploadAttachment: {
              customUpload: (file, insertFn) => {
                _this.uploadFile(file, insertFn, 'attachment');
              }
            }
          },
          scroll: false,
          onChange (editor) {
            _this.onChange(editor)
          },
        },
        mode: 'default'
      })
      // 创建工具栏
      const toolbar = window.wangEditor.createToolbar({
        editor: weditortool,
        selector: `#toolbar-container_${_this.hash}`,
        config: _this.toolbarConfig,
        mode: 'default'
      })
      this.weditortool = Object.seal(weditortool);
      // 初始化数据
      if (this.value) this.insertText(this.value)
      if(this.isDesign){
        this.insertText(this.designerEditorHtml)
      }
      this.$nextTick(() => {
        let h = this.$refs.editorToolbar?.offsetHeight
        this.$refs.editorToolbar.style.top = this.fixToolbar ? `${this.fixedOffsetTop}px` : '0px';
        if(this?.$refs?.editorSidebar){
          let top = this.$refs.editorSidebar?.getBoundingClientRect().top - 20 + 'px'
          this.$refs.editorSidebar.style.top = this.readOnly ? top : this.fixToolbar ? `${h + 20 + this.fixedOffsetTop}px` : '20px'
        }
        // this.$refs.editorInput.style.minHeight = `${this.richTxtHeight - h - 36}px`
        // this.treeHeight = parseInt(this.richTxtHeight - h - 76)
      })
      if (this.readOnly) {
        this.weditortool.disable()
        this.weditortool.blur()
      }
    },
    handleScroll: _.debounce(function(){
      let ele;
      if (this.fixedOffsetClass) {
        ele = document.getElementsByClassName(this.fixedOffsetClass)[0]
      } else {
        ele = document.documentElement
      }
      let scrollTop = ele.scrollTop
      let clientHeight = ele.clientHeight;
      let scrollHeight = ele.scrollHeight;
      let editorToolbarHeight = 0;
      if(this.$refs?.editorToolbar?.clientHeight){
        editorToolbarHeight = this.$refs.editorToolbar.clientHeight
      }
      if(this.weditortool?.getElemsByTypePrefix){
        let headerList = this.weditortool.getElemsByTypePrefix('header');
        if(headerList.length > 0  && this.needScrollJudge){
          try {
            headerList.forEach((item,i)=>{
              let offsetTopValue = this.$el.querySelector(`#${item.id}`).getBoundingClientRect().top;
              if(offsetTopValue > 0 && offsetTopValue >= editorToolbarHeight && offsetTopValue - editorToolbarHeight < 25){
                this.currentNodeKey = item.id;
                throw Error();
              }else if(offsetTopValue > 0 && offsetTopValue >= editorToolbarHeight && offsetTopValue - editorToolbarHeight >= 25){
                this.currentNodeKey = this.headerList[i-1].id;
                throw Error();
              }
            })
          } catch (error) {
            //
          }
          if(scrollTop == 0){
            this.currentNodeKey = this.headerList[0].id;
          }
          if(scrollTop + clientHeight >= scrollHeight){
            this.currentNodeKey = this.headerList[this.headerList.length-1].id;
          }
        }
      }
      this.needScrollJudge = true;
    },50),
    insertText (v) {
      this.weditortool.clear()
      this.weditortool.setHtml(v)
    },
    handleClickInput (e) {
      if (this.weditortool && e.target.className?.includes && e.target.className?.includes('editor-input')) {
        this.weditortool.blur()
        this.weditortool.focus(true) // 聚焦到末尾
      }
    },
    getFormItemBlockMarginLeft() {
      if (this.$labelWidth && this.hasLabel) {
        return {
          "margin-left": this.$labelWidth + "px"
        };
      }
      return {
        "margin-left": 0
      };
    },
    setEditorSidebarPos () {
      let h = this.$refs.editorToolbar?.offsetHeight ? this.$refs.editorToolbar.offsetHeight : 0
      let top = this.$refs.editorSidebar?.getBoundingClientRect().top - 20 + 'px'
      return {
        "top": (!this.isHideMenu || this.readOnly) ? top : this.fixToolbar ? `${h + 20 + this.fixedOffsetTop}px` : '20px',
        // "margin-top": this.fixToolbar ? '0' : '20px'
      };
    },
    onChange: _.debounce(function(editor) {
      if (editor.getHtml() !== '<p><br></p>') this.emitValueChange(editor.getHtml());
      if(!this.isDesign){
        let headerList = editor.getElemsByTypePrefix('header');
        if (JSON.stringify(headerList) !== JSON.stringify(this.headerList)) {
          this.headerList = headerList
        }
      }
      this.wordSizeCount(editor)
      this.$emit("editor-change",{data:editor.getHtml()});
    },50),
    wordSizeCount (editor) {
      let text = editor.getText().replace(/\n|\r/mg, '').length
      let left = this.maximumWords - text
      this.msgCountTip = this.wordCountMsg.replace('{#count}', text).replace('{#leave}', left)
      if (left < 0) {
        this.$nextTick(() => {
          editor.undo()
        })
      }
    },
    renderNewEditor () {
      this.showEditor = false;
      this.toolbarConfig.toolbarKeys = this.toolBars;
      this.$nextTick(() => {
        this.weditortool = null
        this.showEditor = true;
        this.$nextTick(() => {
          this.initEditor()
        })
      });
    },
    /* 目录树的方法 */
    //目录树节点点击锚点跳转方法
    nodeClick:_.debounce(function(obj,node,event) {
      this.$nextTick(()=>{
        let target = this.$el.querySelector(`#${obj.id}`);
        let parent
        if (this.fixedOffsetClass) {
          parent = document.getElementsByClassName(this.fixedOffsetClass)[0]
        } else {
          parent = document.documentElement
        }
        parent.scrollTo({left:0,top:target.offsetTop + parent.offsetTop - 20,behavior: "smooth"});
      })
      this.needScrollJudge = false;
      this.currentNodeKey = obj.id; 
    },50),
    //全部展开/全部折叠方法
    isOpenOrClose(){  
      this.isExpand = !this.isExpand;
      this.isCloseAll = !this.isCloseAll;
      const treeNodes = this.$refs.menuTree.store._getAllNodes();
      if(treeNodes.length>0){
        treeNodes.forEach((item=>{
          this.$set(item,"expanded",this.isExpand)
        }))
      }
    },
    //判断目录树是否有第二级时，全部展开/全部折叠是否显示
    isShowCloseTree(list){
      let isShow = false;
      try {
        list.forEach((item)=>{
          if(item.children?.length){
            isShow = true;
            throw Error();
          }
        })
      } catch (error) {
        //
      }
      return isShow
    },
    //树节点展开事件
    nodeExpand(obj,node,event){
      this.$set(node,"expanded",true);
      const treeNodes = this.$refs["menuTree"].store._getAllNodes();
      let judgeArr = treeNodes.filter(item => item.childNodes.length > 0)
      let isAllExpand = true;
      try {
        judgeArr.forEach(item=>{
          if(!item.expanded){
            isAllExpand = false;
          }
        })
      } catch (error) {
        //
      }
      if(isAllExpand){
        this.isExpand = true;
        this.isCloseAll = false;
      }else{
        this.isExpand = false;
      }
    },
    //树节点关闭事件
    nodeCollapse(obj,node,event){
      this.$set(node,"expanded",false);
      const treeNodes = this.$refs["menuTree"].store._getAllNodes();
      this.isExpand = false;
      if(node.level == 1){
        let newArr = treeNodes.filter(item => item.level == 1);
        let isAllClose = true;
        try {
          newArr.forEach(item=>{
            if(item.expanded){
              isAllClose = false;
              throw Error();
            }
          })
        } catch (error) {
          //
        }
        if(isAllClose){
          this.isCloseAll = true;
        }else{
          this.isCloseAll = true;
        }
      }else{
        this.isCloseAll = true;
      }
    },
    //检测富文本中哪一个h标签离页面顶部最近
    judgeTopItem(list){
      if(list?.length){
        let newArr = list.filter(item => item.top > -1)
        let arr = [];
        newArr.forEach(item=>{
          arr.push(item.top)
        })
        let minItem = Math.min(...arr);
        let minIndex = arr.findIndex((item)=>{
          return item === minItem;
        })
        return {
          id:minIndex > -1 && newArr.length? newArr[minIndex].id : list[list.length-1].id,
          index:minIndex
        }
      }
    },
    /* 目录树的方法完 */
    uploadFile (file, insertFn, type) {
      let loading = dsf.layer.loading({text: '上传中...'});
      this.$http.upload(this.upFileUrl, {files: file},{ timeout:0}).done(({success, data, message}) => {
        if (!success) {
          dsf.layer.message(message || '上传失败', false);
          reject(message);
          return;
        }
        const src = dsf.url.getWebPath(data[0]["relativePath"]);
        if (type === 'attachment') {
          insertFn(`${file.name}`, src)
        } else {
          insertFn(src)
        }
      }).error((err) => {
        dsf.layer.message("上传发生未知异常", false);
        reject(err);
      }).always(() => {
        dsf.layer.closeLoading(loading);
      });
    },
    handleHideMenu () {
      this.isHideMenu = !this.isHideMenu
      this.$emit('fixMenu', this.isHideMenu)
      setTimeout(() => {
        this.isHover = !this.isHideMenu
      }, 10)
    },
    returnResetWidth(){
      return `width: ${parseInt(this.resetWidth)}px !important`
    }
  },
  beforeDestroy() {
    const editor = this.weditortool;
    if (editor == null) return;
    editor.destroy(); // 组件销毁时，及时销毁 editor ，重要！！！
    if (this.fixedOffsetClass) {
      document.getElementsByClassName(this.fixedOffsetClass)[0].removeEventListener("scroll", this.handleScroll, true);
    } else {
      window.removeEventListener("scroll", this.handleScroll, true);
    }
  },
});
</script>
